<template>
  <div class="main-div">
    <DragHeader />
    <button class="close" @click="clickCloseButton" />
    <div class="amount"> {{ couponDisplayAmount }} </div>
    <button class="use" @click="clickUseButton">立即使用</button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import client from '@/client'
import DragHeader from '@/components/common/DragHeader.vue'
import { getCouponConfig } from '@/api/coupon.js'

const ACT_FRM = 'act_20210810_dg_driverquitpop_client_data'

const ClickReport = {
  close: 1,
  jump: 2
}

export default {

  components: {
    DragHeader
  },

  data () {
    return {
      couponAmount: 0
    }
  },

  computed: {
    ...mapGetters([
      'isMember'
    ]),

    couponDisplayAmount () {
      return this.couponAmount
    }
  },

  created () {
    this.init()
  },

  methods: {
    async init () {
      const data = await getCouponConfig({ frm: ACT_FRM })
      let config = {}
      if (data?.resp_common?.ret === 0) {
        config = data?.act_show[ACT_FRM]?.config
      }
      this.couponAmount = parseInt(config.coupon) || 0
    },

    clickCloseButton () {
      this.report(ClickReport.close)
      window.close()
    },

    toMemberCenter () {
      client.common.API.client_openOptionWindow({
        open_web: 'charge_drivergenius',
        popup:true // 弹出式的窗口，才不会关闭当前窗口时被一起关闭
      })
    },

    async clickUseButton () {
      this.report(ClickReport.jump)
      await this.toMemberCenter()
      window.close()
    },

    report (click) {
      client.coupon.REPORT.reportRenewClick({ click })
    }
  },
}
</script>

<style scoped lang="scss">
.base-button {
  position: absolute;
  cursor: pointer;
  outline: none;
  border: none;
  background-color: transparent;
}

.main-div {
  width: 352px;
  height: 372px;
  background: url('./_images/bg.png');
  user-select: none;

  .close {
    z-index: 3;
    -webkit-app-region: no-drag;
    @extend .base-button;
    width: 20px;
    height: 20px;
    right: 13px;
    top: 13px;
    background-image: url('./_images/close.png');
    &:hover {
      background-position: -20px;
    }
    &:active {
      background-position: -40px;
    }
  }

  .amount {
    cursor: default;
    position: absolute;
    font-size: 55px;
    font-weight: bold;
    color: #F73C23;
    top: 119px;
    right: 180px
  }

  .use {
    @extend .base-button;
    width: 300px;
    height: 53px;
    border-radius: 24px;
    font-size: 23px;
    font-weight: bold;
    color: #f73a21;
    line-height: 40px;
    left: 50%;
    transform: translate(-50%);
    bottom: 35px;
    background-color: #fad117;
    &:hover {
      background-color: #fddf2b;
    }
    &:active {
      background-color: #e8c418;
    }
  }
}
</style>
